/* eslint react-hooks/exhaustive-deps: "warn" */
import { type CSSProperties, useRef } from 'react';

import cn from 'classnames';

import { useIntersection } from 'hooks/useIntersection';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './NumberedRowsSection.module.scss';

import type { NumberedRowsSectionProps } from './NumberedRowsSection.types';

export const NumberedRowsSection = ({
  eyebrow,
  heading,
  description,
  rows,
  actions,
  className,
}: NumberedRowsSectionProps) => {
  const listRef = useRef<HTMLDivElement>(null);
  const revealed = useIntersection(listRef, { threshold: 0.1 });

  return (
    <Section className={cn(styles.root, className)}>
      <div className={styles.grid}>
        <div className={cn(styles.list, revealed && styles.listOn)} ref={listRef}>
          {rows.map((row, i) => (
            <div className={styles.row} style={{ '--d': `${i * 60}ms` } as CSSProperties} key={row.index}>
              <span className={styles.rowN}>{row.index}</span>
              <div className={styles.rowBody}>
                <h3 className={styles.rowTitle}>{row.title}</h3>
                <div className={styles.rowText}>{row.body}</div>
              </div>
              <svg
                className={styles.rowArrow}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                aria-hidden="true"
              >
                <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          ))}
        </div>

        <div className={styles.aside}>
          <TitleBlock
            align="left"
            extra={eyebrow}
            title={heading}
            description={description}
            className={styles.titleBlock}
          />
          {actions && <div className={styles.asideCta}>{actions}</div>}
        </div>
      </div>
    </Section>
  );
};
